import { Box, Checkbox, FormControlLabel, FormGroup, FormHelperText, FormLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';

type Props = {
  label?: string;
  values: string[];
  options: any[];
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  fullWidth?: boolean;
  error?: string;
  direction?: 'row' | 'column';
  maxOptionsPerColumn?: number;
  onChange: (value: string[]) => void;
};

const CheckboxGroup = ({
  label,
  values = [],
  options = [],
  required,
  disabled,
  fullWidth = true,
  error,
  autoFocus,
  direction = 'column',
  maxOptionsPerColumn = 5,
  onChange,
}: Props) => {
  const handleChange = (value: string, selected: boolean) => {
    if (selected) {
      onChange([...values, value]);
    } else {
      onChange(values.filter((v: string) => v !== value));
    }
  };

  return (
    <FormControl fullWidth={fullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}

      <Box sx={{ padding: '4px' }}>
        <FormGroup
          autoFocus={autoFocus}
          sx={{
            display: options.length > maxOptionsPerColumn ? 'grid' : 'flex',
            gridAutoFlow: 'column',
            gridTemplateRows: options.length > maxOptionsPerColumn ? `repeat(${maxOptionsPerColumn}, auto)` : 'none',
            flexDirection: direction === 'row' ? 'row' : 'column',
            gap: 0,
          }}
        >
          {options.map((option: any) => {
            return typeof option === 'string' ? (
              <FormControlLabel
                key={option}
                value={option}
                control={
                  <Checkbox
                    size="small"
                    checked={values.includes(option)}
                    onChange={(event) => {
                      handleChange(option, event.target.checked);
                    }}
                    disabled={disabled}
                  />
                }
                label={option}
              />
            ) : (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Checkbox
                    size="small"
                    checked={values.includes(option.value)}
                    onChange={(event) => {
                      handleChange(option.value, event.target.checked);
                    }}
                    disabled={disabled || option.disabled}
                  />
                }
                label={option.label || option.value}
              />
            );
          })}
        </FormGroup>
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxGroup;
